module.exports = __webpack_public_path__ + "static/media/DSC04153.08f14cad.JPG";